import * as React from 'react';
import { Store } from 'redux';

import { createMakeRequest } from '../../../browser/client';
import { getUserData } from '../../reducers/modules/user';
import { ACTIVE_EXPERIMENTS, getExperimentsFlags } from '../../reducers/modules/mainpage';
import { Header } from '../../components/header/header';

const styles = require('./app.css');

interface IProps {
  store?: Store;
}

export class App extends React.Component<IProps, {}> {
  public componentDidMount() {
    const { store } = this.props;

    if (store) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const host = window.__mainpage_api_host__ || window.location.host;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      store.dispatch(getUserData(host) as any);

      getExperimentsFlags(
        store.dispatch,
        createMakeRequest(host),
        ACTIVE_EXPERIMENTS,
        window.location.search.replace('?', ''),
      );
    }
  }

  public render() {
    return (
      <section id={styles['mainpage']}>
        <Header />
        {this.props.children}
      </section>
    );
  }
}
